<div class="footer_container">
  <div nxLayout="grid maxwidth">
    <div nxRow>
      <nx-footer class="footer-medium">
        <nx-footer-copyright>
          <p nxCopytext="medium" class="nx-font-weight-bold">
            &copy; Allianz {{ currentYearLong() }}. All Rights Reserved.
          </p>
        </nx-footer-copyright>

        <nx-footer-navigation>
          <nx-footer-link>
            <a routerLink="./" nxCopytext="medium">Legal Notes</a>
          </nx-footer-link>

          <nx-footer-link>
            <a routerLink="./" nxCopytext="medium">Privacy Principles</a>
          </nx-footer-link>

          <nx-footer-link>
            <a routerLink="./" nxCopytext="medium">Terms of Use</a>
          </nx-footer-link>
        </nx-footer-navigation>
      </nx-footer>
    </div>
  </div>
</div>
<div *ngIf="showScrollButton" class="to-top nx-hidden-m nx-hidden-l nx-hidden-xl nx-hidden-2xl nx-hidden-3xl"
  (click)="scrollToTop()">
  <img src="assets/img/shared/scroll-top.png" alt="scroll-top.png"/>
</div>